export const PARAMS_NAME = {
    partnerRequests: 'Partner Requests',
    winsPercent: 'Win %'
};
export const NAN_PARAMS = {
    name: 1,
    url: 1,
};


// WEBPACK FOOTER //
// ./src/scenes/BidderFeeds/config.js